/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * * `BUYER` - Buyer * `SELLER` - Seller * `BROKER` - Broker * `BUYER_AGENT` - Buying Agent * `BUYER_AGENT_ADMIN` - Buying Agent Admin * `SELLER_AGENT` - Selling Agent * `SELLER_AGENT_ADMIN` - Selling Agent Admin * `TRANSPORTER` - Transporter
 * @export
 * @enum {string}
 */
export enum BookingContactRoleEnum {
    Buyer = 'BUYER',
    Seller = 'SELLER',
    Broker = 'BROKER',
    BuyerAgent = 'BUYER_AGENT',
    BuyerAgentAdmin = 'BUYER_AGENT_ADMIN',
    SellerAgent = 'SELLER_AGENT',
    SellerAgentAdmin = 'SELLER_AGENT_ADMIN',
    Transporter = 'TRANSPORTER'
}



